import { render, staticRenderFns } from "./correccionespuntuales.vue?vue&type=template&id=c54f071c"
import script from "./correccionespuntuales.vue?vue&type=script&lang=js"
export * from "./correccionespuntuales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports